import { Link } from "react-router-dom";
import { useLanguage } from "@/i18n/LanguageContext";

export default function Footer() {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  const serviceLinks = [
    { labelKey: "home.servicesSliding", path: "/sliding-door-repair" },
    { labelKey: "home.servicesGlass", path: "/glass-replacement" },
    { labelKey: "home.servicesHardware", path: "/window-hardware-repair" },
    { labelKey: "home.servicesWeather", path: "/weatherstripping-sealing" },
    { labelKey: "home.servicesMaint", path: "/window-cleaning-maintenance" },
    { labelKey: "home.servicesBoardup", path: "/emergency-board-up" },
  ];

  const serviceAreas = [
    { name: "Brickell", slug: "brickell" },
    { name: "Aventura", slug: "aventura" },
    { name: "Miami Beach", slug: "miami-beach" },
    { name: "Coral Gables", slug: "coral-gables" },
    { name: "Coconut Grove", slug: "coconut-grove" },
    { name: "Doral", slug: "doral" },
    { name: "Kendall", slug: "kendall" },
    { name: "Pinecrest", slug: "pinecrest" },
    { name: "Bay Harbor Islands", slug: "bay-harbor-islands" },
    { name: "Key Biscayne", slug: "key-biscayne" },
    { name: "South Miami", slug: "south-miami" },
    { name: "North Miami Beach", slug: "north-miami-beach" },
  ];

  const companyLinks = [
    { labelKey: "nav.serviceAreas", to: "/service-areas/" },
    { labelKey: "nav.stories", to: "/reviews/" },
    { labelKey: "nav.blog", to: "/blog/" },
    { labelKey: "footer.accessibility", to: "/accessibility/" },
    { labelKey: "footer.privacy", to: "/privacy-policy/" },
    { labelKey: "footer.terms", to: "/terms-of-service/" },
    { labelKey: "footer.legal", to: "/legal-disclaimer/" },
  ];

  return (
    <footer className="bg-secondary text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 md:px-6 pt-16 pb-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Col 1 - Logo & Contact */}
          <div>
            <h3 className="text-lg font-bold text-white mb-1">
              Windows and Doors Repair LLC
            </h3>
            <p className="text-xs text-[#fefce8] mb-4">
              {t("footer.tagline")}
            </p>
            <a
              href="tel:+17863774452"
              className="text-base font-bold text-white hover:text-[#fefce8] transition-colors block mb-2"
            >
              (786) 377-4452
            </a>
            <a
              href="mailto:contact@impact-window-repair-miami.com"
              className="text-xs text-[#fefce8] hover:text-white transition-colors block"
            >
              contact@impact-window-repair-miami.com
            </a>
            <p className="text-xs text-[#fefce8] mt-2 leading-relaxed">
              848 Brickell Ave, PH-5<br />
              Miami, FL 33131
            </p>
          </div>

          {/* Col 2 - Repair Services */}
          <div>
            <h4 className="text-sm font-bold text-white mb-4">
              {t("footer.services")}
            </h4>
            <ul className="space-y-2.5">
              {serviceLinks.map((s) => (
                <li key={s.path}>
                  <Link
                    to={s.path}
                    className="text-xs text-[#fefce8] hover:text-white transition-colors"
                  >
                    {t(s.labelKey)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 3 - Service Areas */}
          <div>
            <h4 className="text-sm font-bold text-white mb-4">
              {t("footer.areas")}
            </h4>
            <div className="grid grid-cols-2 gap-x-4 gap-y-2.5">
              {serviceAreas.map((area) => (
                <Link
                  key={area.slug}
                  to={`/impact-windows-${area.slug}/`}
                  className="text-xs text-[#fefce8] hover:text-white transition-colors"
                >
                  {area.name}
                </Link>
              ))}
            </div>
          </div>

          {/* Col 4 - Company */}
          <div>
            <h4 className="text-sm font-bold text-white mb-4">
              {t("footer.company")}
            </h4>
            <ul className="space-y-2.5">
              {companyLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-xs text-[#fefce8] hover:text-white transition-colors"
                  >
                    {t(link.labelKey)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Strip */}
      <div className="border-t border-primary">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-[#fefce8]">
            &copy; {currentYear} Windows and Doors Repair LLC. {t("footer.rights")}
          </p>
          <p className="text-xs text-[#fefce8] italic">
            {t("footer.texasLLC")}
          </p>
        </div>
      </div>

      {/* Legal Disclaimer */}
      <div className="bg-[#022c22]">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-5 text-center">
          <p className="text-xs text-[#fefce8] italic leading-relaxed">
            {t("footer.serviceDescription")}
          </p>
        </div>
      </div>
    </footer>
  );
}